import {
  ExpressionPath,
  Type,
  CheckerState,
  VariableMap,
  EnvTypes,
  setValues,
} from '@packages/systems/wfdl';
import {Expression, TUnknown} from '@packages/systems/wfdl-ast';
import {ExpressionEditorActionPayload} from '@packages/systems/ExpressionEditor-utils';
import {pluginName, qualify} from '@packages/systems/wfdl-Qualified';
import {weakMemo} from '@packages/utilities/memo';

// fallback for the required analytics.meta.dataType property of the
// EXPRESSION_BIND_CHANGED action payload if annotated expression type is null
const FallbackAnalyticsMetaType = TUnknown({id: -1, rigids: {}});

export function bindChangedAt(
  binding: Expression | null,
  dataType: Type | null,
  key: ExpressionPath,
  analyticsType:
    | 'conditional-changed'
    | 'conditional-source-selected'
    | 'remove-conditional' = 'conditional-changed'
): ExpressionEditorActionPayload {
  return {
    type: 'EXPRESSION_BIND_CHANGED',
    binding,
    key,
    meta: {
      analytics: {
        dataType: dataType || FallbackAnalyticsMetaType,
        type: analyticsType,
        from: 'node-settings',
      },
    },
  };
}

const SLOTS_PLUGIN_NAME = pluginName('Slots');
const LIST_OF_ELEMENTS_PLUGIN_NAME = pluginName('ListOfElements');

const updatePluginExportVisibility = (
  envTypes: VariableMap.Map<EnvTypes.NormalizedEnvType>,
  plugin: string,
  exported: EnvTypes.NormalizedEnvType['exported']
) => {
  const plugins = VariableMap.getPlugins(envTypes);
  const updatedPlugins = plugins.reduceAtPluginName(
    plugin,
    (acc, envType, valueName) =>
      envType.exported === exported
        ? acc
        : acc.set(qualify(plugin, valueName), {
            ...envType,
            exported,
          }),
    plugins
  );
  return updatedPlugins === plugins
    ? envTypes
    : {...envTypes, plugins: updatedPlugins};
};

const enableSlotContentOperations = weakMemo(
  (envTypes: VariableMap.Map<EnvTypes.NormalizedEnvType>) => {
    const withSlotValuesVisible = updatePluginExportVisibility(
      envTypes,
      SLOTS_PLUGIN_NAME,
      'visible'
    );
    return updatePluginExportVisibility(
      withSlotValuesVisible,
      LIST_OF_ELEMENTS_PLUGIN_NAME,
      'hidden'
    );
  }
);

export function withSlotContentOperationsEnabled(
  state: CheckerState
): CheckerState {
  return setValues(enableSlotContentOperations(state.env.context.values))(
    state
  );
}
